import { render, staticRenderFns } from "./MassiveSettingsDashboard.vue?vue&type=template&id=07c83c98&lang=pug"
import script from "./MassiveSettingsDashboard.vue?vue&type=script&lang=js"
export * from "./MassiveSettingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./MassiveSettingsDashboard.vue?vue&type=style&index=0&id=07c83c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports